/*  wholesale-snapshot.js  |  fügt je Variante versteckte Snapshot-Inputs ein  */
(() => {
  /* Liefert das Variant-Objekt aus JSON-Script in product.liquid */
  function getVariantById(id) {
    /* Shopify lädt alle Varianten in window.__PRELOADED_STATE__, Fallback product JSON */
    const variants = window.__PRELOADED_STATE__?.product?.variants
                 || window?.Shopify?.product?.variants
                 || [];
    return variants.find(v => String(v.id) === String(id));
  }

  /* Baut/aktualisiert hidden inputs für eine Tabellenzeile */
  function injectSnapshot(row) {
    const qtyInput = row.querySelector('input[name^="updates["]');
    if (!qtyInput) return;

    const variantId = qtyInput.name.match(/\d+/)?.[0];
    if (!variantId) return;

    /* Schon drin? – dann nichts mehr tun */
    if (row.querySelector('input[name="properties[_snapshot_stock_now]"]')) return;

    const variant  = getVariantById(variantId);
    if (!variant) return;

    const mf      = variant.metafields?.custom || {};
    const stock   = mf.sofort_verfugbar?.value || 0;
    const dateRaw = mf.purchase_date?.value    || '';

    /* Zwei versteckte Inputs an den Varianten-Container hängen */
    const hiddenStock       = document.createElement('input');
    hiddenStock.type        = 'hidden';
    hiddenStock.name        = 'properties[_snapshot_stock_now]';
    hiddenStock.value       = stock;

    const hiddenDate        = document.createElement('input');
    hiddenDate.type         = 'hidden';
    hiddenDate.name         = 'properties[_snapshot_date]';
    hiddenDate.value        = dateRaw;

    qtyInput.parentNode.appendChild(hiddenStock);
    qtyInput.parentNode.appendChild(hiddenDate);
  }

  /* Initiale Matrix durcharbeiten */
  function processMatrix() {
    document
      .querySelectorAll('.nm-easywholesale-table [class*="nm-wholesale-table-item"]')
      .forEach(injectSnapshot);
  }

  /* 1) Beim ersten Seiten-Load */
  document.addEventListener('DOMContentLoaded', processMatrix);

  /* 2) Easy-Wholesale rendert die Tabelle per Ajax → MutationObserver genügt */
  const observer = new MutationObserver(processMatrix);
  observer.observe(document.body, { childList: true, subtree: true });

  /* 3) Sicherheitshalber: wenn App einen eigenen Event feuert */
  document.addEventListener('nm:wholesale-table-rendered', processMatrix);
})();